import {trigger,state,style,animate,transition,AUTO_STYLE} from '@angular/animations';

export const GenericoSlideAnim =
        trigger('openClose', [
            // ...
            // AUTO_STYLE (no 'inherit'): 'inherit' hace que el elemento HEREDE
            // el display de su padre, pisando cualquier display propio (ej.
            // display:flex de .pestacarrito en carrito-generico), porque un
            // style inline siempre le gana a la regla de clase. AUTO_STYLE le
            // pide a Angular que restaure el display que el CSS del propio
            // elemento define, sea flex, block, grid, etc.
            state('open', style({
            display: AUTO_STYLE,
            })),
            state('closed', style({
            display: 'none',
            })),
        ]);
